// extracted by mini-css-extract-plugin
module.exports = {"save_button":"_1GRc8B7","connect_button":"_3WlkdDr"};